import * as React from "react";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ApplyModel } from "../../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { HierarchyIdHelper } from "../../../../../../../Shared/Common/HierarchyIdHelper";
import {
    getISTPaymentAmount,
    pensionInstrumentSelectionToInstrumentSelection,
} from "../../../../../../../Shared/IST/Components/Shared/Utils";
import { InvestmentSelectionTool as IST } from "../../../../../../../Shared/IST/InvestmentSelectionTool";
import { ProcessType } from "../../../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { WizardLinter, EWizardLinterStatus } from "../../../../../../../Shared/Process/Process/WizardLinter";
import { Action } from "../../../../../../Actions/Action";
import { TreasuredAssetsStore } from "../../../../../../Stroes/Variable";
import { SubAccountTypeHelper } from "../../../../Common/Helpers/SubAccountTypeHelper";
import { BankAccountOwnerPaymentTypeMap, PaymentType } from "../../../../Common/Resource/Contents";
import { EWizardLinterHelper } from "../../../Resource/EWizardLinterHelper";
import { AdviserContextStoreStatic } from "../../../Stores/Variable";

interface InvestmentSelectionToolProps extends IProcessComponentProps {
    data: ApplyModel;
    treasuredAssetProductIds: number[];
    onTreasuredAssetsStoreChange: () => void;
    onChangeTreasuredAssets: (subAccountInstructionId, productId, value) => void;
}

interface InvestmentSelectionToolState { }

export class InvestmentSelectionTool extends ProcessComponent<
    InvestmentSelectionToolProps,
    InvestmentSelectionToolState
> {
    constructor(props: any) {
        super(props);
        this.state = {};
        this.subscribeToStore(TreasuredAssetsStore, () => this.props.onTreasuredAssetsStoreChange());
        this.ensureAllAllocationsAreSame();
    }

    componentDidMount() {
        super.componentDidMount();
        const subAccountInstructionId = HierarchyIdHelper.generateHierarchyId(this.props.data.IsaModel.HierarchyId)
            .entityId;
        Action.getInstructionTreasuredAssetsProductIds(subAccountInstructionId);
    }

    public render(): JSX.Element {
        const { onChange, data, onChangeTreasuredAssets, treasuredAssetProductIds } = this.props;
        const paymentAmount = getISTPaymentAmount(data?.IsaModel, "IsaTransfers");
        const accountsFromExisting = data.AllBankAccounts || [];
        const bankAccountInstructionsFiltered =
            (data.BankAccountInstructions || []).filter(
                (x) => BankAccountOwnerPaymentTypeMap[x.Owner].indexOf(PaymentType.Client) != -1
            ) || [];

        const bankAccounts = [...accountsFromExisting, ...bankAccountInstructionsFiltered];
        const modelData = JSON.parse(JSON.stringify(data?.IsaModel));
        modelData.CashInstrument = data.CashInstrument;
        modelData.OwnerHierarchyId = data.OwnerHierarchyId;
        const hasSipp = this.props.data.SelectedProducts.some((ele) =>
            SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType)
        );
        const adviser = AdviserContextStoreStatic.getData();
        return (
            <WizardLinter
                status={EWizardLinterStatus.PleaseCheck}
                enabled={EWizardLinterHelper.shouldDisplay(SubAccountType.StocksIsa)}
            >
                <h2 className="mb-20">Investment selection</h2>
                <IST
                    withReRegistrationTransferIn={false}
                    data={data?.IsaModel?.InstrumentSelections}
                    modelData={modelData}
                    onRef={(ref) => this.appendChild(ref)}
                    onChange={(changes) =>
                        this.onDataChange(
                            (changes) => this.onDataChange(onChange, changes, data, "IsaModel"),
                            changes,
                            data.IsaModel,
                            "InstrumentSelections"
                        )
                    }
                    from={hasSipp ? SubAccountType.Sipp : null}
                    fromData={
                        hasSipp
                            ? pensionInstrumentSelectionToInstrumentSelection(
                                data.PensionApply?.PreRetirementInstrumentSelections,
                                data.PensionApply?.PostRetirementInstrumentSelections,
                                data.CashInstrument
                            )
                            : null
                    }
                    showErrorMsgPopUp={(msg) => this.props.showErrorMsgPopUp(msg)}
                    type={ProcessType.NB}
                    hiercharyId={data.SubaccountInstructionHierarchyId}
                    headAccountHierarchyId={data.ExistingAccountHierarchyId}
                    companyCode={adviser?.Company}
                    claccountId={this.props.data.ClAccountId}
                    product={SubAccountType.StocksIsa}
                    paymentAmount={{ Amount: paymentAmount, Currency: CurrencyCode.GBP }}
                    bankAccounts={bankAccounts}
                    onBankChange={(bankInfo) => {
                        const banks = data.BankAccountInstructions.concat(bankInfo);
                        onChange({ BankAccountInstructions: banks });
                    }}
                    onDistributionDividendOptions={(changes) => {
                        this.onDataChange(
                            (changes) => this.onDataChange(onChange, changes, data, "IsaModel"),
                            changes,
                            data.IsaModel,
                            "DistributionDividendOptions"
                        );
                    }}
                    decisionMakerHierarchyId={data?.IsaModel?.HierarchyId}
                    accountAdviceType={data?.AccountAdviceType}
                    accountServiceProposition={data?.AccountServiceProposition}
                    onDecisionMakerChange={(v) => this.onDataChange(onChange, v, data, "IsaModel")}
                    treasuredAssetsProductIds={treasuredAssetProductIds}
                    onChangeTreasuredAssets={(productId, value) => {
                        onChangeTreasuredAssets(data.IsaModel.HierarchyId, productId, value);
                    }}
                />
            </WizardLinter>
        );
    }

    private ensureAllAllocationsAreSame(): void {
        const { IsaModel } = this.props.data;
        for (let i = 0; i < IsaModel.InstrumentSelections?.Instruments?.length; i++) {
            if (IsaModel.IsaTransfers?.length > 0 && IsaModel.InstrumentSelections?.Instruments[i]?.Transfer.Percentage == 0 && IsaModel.InstrumentSelections?.Instruments[i]?.Single?.Percentage !== 0) {
                IsaModel.InstrumentSelections.Instruments[i].Transfer.Percentage = IsaModel.InstrumentSelections?.Instruments[i]?.Single?.Percentage;
            }
        }
    }
}
